module.exports = __webpack_public_path__ + "img/solar-p.d27d19a0.png";